/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Source_YoutubeInputs */



/**
* | output |
* | --- |
* | "YouTube" |
*
* @param {New_Project_Media_Source_YoutubeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_source_youtube = /** @type {((inputs?: New_Project_Media_Source_YoutubeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Source_YoutubeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("YouTube")
	if (locale === "de") return /** @type {LocalizedString} */ ("YouTube")
	if (locale === "it") return /** @type {LocalizedString} */ ("YouTube")
	if (locale === "ru") return /** @type {LocalizedString} */ ("YouTube")
	if (locale === "es") return /** @type {LocalizedString} */ ("YouTube")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("YouTube")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーチューブ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यूट्यूब")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("YouTube")
	return /** @type {LocalizedString} */ ("YouTube")
});